import InboundPage from '../pages/dashboard';
export default [
    {
        path:'/dashboard/:direction',
        exact:true,
        Component:InboundPage
    },
];